/* eslint-disable react/require-default-props */

import Logo1X from '@/assets/Logo.png';
import Logo2X from '@/assets/Logo@2x.png';
import Logo3X from '@/assets/Logo@3x.png';

export default function LogoIcon({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) {
  return (
    <picture
      style={{
        height,
        width,
      }}
    >
      <source srcSet={`${Logo1X}, ${Logo2X} 2x, ${Logo3X} 3x`} />
      <img
        style={{
          objectFit: 'contain',
        }}
        src={Logo1X}
        alt="Apple calendar logo"
      />
    </picture>
  );
}

LogoIcon.defaultProps = {
  width: '191px',
  height: '207px',
};
